var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"mb-2",attrs:{"items":_vm.trainings,"item-value":"id","item-text":"name","label":"Eğitim","rules":[(v) => !!v || 'Eğitim alanı boş bırakılamaz'],"loading":_vm.loading},model:{value:(_vm.selectedTraining),callback:function ($$v) {_vm.selectedTraining=$$v},expression:"selectedTraining"}})
}
var staticRenderFns = []

export { render, staticRenderFns }